import {ApiConfig} from "../services/api-config";

export function urlBuilder(path: string, subdomain: string, ids: any[]): string {
  if(path.split(':?').length - 1 !== ids.length) {
    throw new Error(`ids [${ids}], does not match url ${path}`)
  }
  return ApiConfig.getApiUrl(path.replaceAll(':?', () => ids.shift()), subdomain);
}
